<section class="section-postos">
<!-- Tabela de postos  -->
<div class="postos-wrapper"> <!--*ngIf="postosSelecionados.length > 0">-->
  <!-- HEADER FIXO -->
  <div class="postos-header">
    <span>
        Postos Selecionados (
          <span
            [ngClass]="{
              'vermelho': postosSelecionados.length === 0,
              'verde': postosSelecionados.length > 0
            }"
          >
            {{ postosSelecionados.length }}
          </span>
          )
    </span>
    <span matSuffix class="input-actions">
        <!--app-acordos-existentes mat-icon-button type="button" matTooltip="Limpar postos" (click)="mostrar()" *ngIf="!readonly">
          <mat-icon>{{ iconeVisibilidade }}</mat-icon>
        </button>-->
      <button
      mat-icon-button
      type="button"
      matTooltip="Mostrar postos Selecionados"
      (click)="alternarVisibilidade()"
      *ngIf="!readonly && postosSelecionados.length > 0">
      <mat-icon>
        {{ mostrarPostos ? 'visibility' : 'visibility_off' }}
      </mat-icon>
    </button>
        <button mat-icon-button type="button" matTooltip="Limpar postos" (click)="limparPostos()" *ngIf="!readonly">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button type="button" matTooltip="Buscar posto" (click)="filtrarEAbrirDialogPosto()" *ngIf="!readonly">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button type="button" matTooltip="Importar Múltiplos Postos"
          (click)="openDialogMultiplosPostos()" *ngIf="!readonly">
          <mat-icon>playlist_add</mat-icon>
        </button>
      </span>

  </div>
  <!-- DROPDOWN / OVERLAY -->
  <div class="postos-scroll-container"
       [class.aberto]="mostrarPostos"
       (scroll)="onPostosScroll($event)"
       (mousewheel)="onPostosScroll($event)">
    <mat-table [dataSource]="postosExibidos" class="mat-elevation-z4">
      <ng-container matColumnDef="codPosto">
        <mat-cell *matCellDef="let posto; let i = index"
                  [class.striped-row]="i % 2 === 0">
          <div class="cell-content">
            {{ posto.codPosto }} - {{ posto.nomeReduzido || posto.nomePosto }}
            <button mat-icon-button matTooltip="Remover posto" (click)="removerPosto(posto)">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  

  <!-- Lista de erros na importação -->
  <div class="listas-alinhadas-container" *ngIf="mostrarErros">
    <section *ngIf="postosSelecionadosErros && postosSelecionadosErros.length > 0" class="section-postos-multiplos">
      <div class="error-container mat-elevation-z4">
        <div class="error-header">
          <h3 class="mat-h3 error-title">({{ postosSelecionadosErros.length }}) Erros na importação de postos</h3>
        </div>
        <ul class="error-list">
          <li *ngFor="let erro of postosSelecionadosErros" class="error-item">
            <mat-icon color="warn">error_outline</mat-icon>
            <span class="error-message">
              <strong>Linha {{ erro.linha }}:</strong>
              {{ erro.mensagem }}
              <ng-container *ngIf="erro.codPosto">
                <strong>(Posto {{ erro.codPosto }})</strong>
              </ng-container>
              <ng-container *ngIf="erro.tipoErro">
                <em class="erro-tipo">[{{ erro.tipoErro }}]</em>
              </ng-container>
            </span>
          </li>
        </ul>
        <div class="error-footer">
          <button mat-raised-button class="limpar-button" (click)="limparErrosImportacao()" *ngIf="!readonly">
            <mat-icon>delete_sweep</mat-icon>
            Limpar Erros
          </button>
        </div>
      </div>
    </section>
  </div>
</div>